"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readOnlyGuestAccountUuid = exports.configUserAccountUuid = exports.systemAccount = exports.systemAccountUuid = exports.systemAccountEmail = exports.coreId = void 0;
const platform_1 = require("@hcengineering/platform");
const classes_1 = require("./classes");
/**
 * @public
 */
exports.coreId = 'core';
/**
 * @public
 */
// TODO: consider removing email?
exports.systemAccountEmail = 'anticrm@hc.engineering';
exports.systemAccountUuid = '1749089e-22e6-48de-af4e-165e18fbd2f9';
exports.systemAccount = {
    uuid: exports.systemAccountUuid,
    role: classes_1.AccountRole.Owner,
    primarySocialId: '',
    socialIds: [],
    fullSocialIds: []
};
exports.configUserAccountUuid = '0d94731c-0787-4bcd-aefe-304efc3706b1';
exports.readOnlyGuestAccountUuid = '83bbed9a-0867-4851-be32-31d49d1d42ce';
exports.default = (0, platform_1.plugin)(exports.coreId, {
    class: {
        Obj: '',
        Doc: '',
        Blob: '',
        AttachedDoc: '',
        Class: '',
        Mixin: '',
        Interface: '',
        Attribute: '',
        Tx: '',
        TxModelUpgrade: '',
        TxWorkspaceEvent: '',
        TxDomainEvent: '',
        TxApplyIf: '',
        TxCUD: '',
        TxCreateDoc: '',
        TxMixin: '',
        TxUpdateDoc: '',
        TxRemoveDoc: '',
        Space: '',
        SystemSpace: '',
        TypedSpace: '',
        SpaceTypeDescriptor: '',
        SpaceType: '',
        Role: '',
        Permission: '',
        AttributePermission: '',
        ClassPermission: '',
        Type: '',
        TypeRelation: '',
        TypeString: '',
        TypeBlob: '',
        TypeIntlString: '',
        TypeHyperlink: '',
        TypeNumber: '',
        TypeFileSize: '',
        TypeMarkup: '',
        TypeRank: '',
        TypeRecord: '',
        TypeBoolean: '',
        TypeTimestamp: '',
        TypeDate: '',
        TypeCollaborativeDoc: '',
        TypePersonId: '',
        TypeAccountUuid: '',
        TypeIdentifier: '',
        RefTo: '',
        ArrOf: '',
        Enum: '',
        EnumOf: '',
        Collection: '',
        TypeAny: '',
        Version: '',
        PluginConfiguration: '',
        UserStatus: '',
        TypeRelatedDocument: '',
        DomainIndexConfiguration: '',
        Configuration: '',
        Status: '',
        StatusCategory: '',
        MigrationState: '',
        BenchmarkDoc: '',
        FullTextSearchContext: '',
        Association: '',
        Relation: '',
        RelationMetadata: '',
        Sequence: '',
        CustomSequence: '',
        ClassCollaborators: '',
        Collaborator: ''
    },
    icon: {
        TypeString: '',
        TypeBlob: '',
        TypeHyperlink: '',
        TypeNumber: '',
        TypeMarkup: '',
        TypeRank: '',
        TypeRecord: '',
        TypeBoolean: '',
        TypeDate: '',
        TypeRef: '',
        TypeArray: '',
        TypeEnumOf: '',
        TypeCollection: '',
        TypePersonId: '',
        Status: '',
        Time: ''
    },
    mixin: {
        ConfigurationElement: '',
        IndexConfiguration: '',
        SpacesTypeData: '',
        TransientConfiguration: '',
        TxAccessLevel: '',
        VersionableClass: '',
        TransientTTL: ''
    },
    space: {
        Tx: '',
        DerivedTx: '',
        Model: '',
        Space: '',
        Configuration: '',
        Workspace: '',
        Domain: ''
    },
    employee: {
        System: '' // An system employee reference.
    },
    account: {
        System: '',
        ConfigUser: ''
    },
    status: {
        ObjectNotFound: '',
        ItemNotFound: ''
    },
    version: {
        Model: ''
    },
    string: {
        Id: '',
        Space: '',
        Spaces: '',
        SpacesDescription: '',
        TypedSpace: '',
        SpaceType: '',
        Modified: '',
        ModifiedDate: '',
        ModifiedBy: '',
        Class: '',
        AttachedTo: '',
        AttachedToClass: '',
        String: '',
        Record: '',
        Markup: '',
        Relation: '',
        Relations: '',
        AddRelation: '',
        Collaborative: '',
        CollaborativeDoc: '',
        MarkupBlobRef: '',
        PersonId: '',
        AccountId: '',
        Number: '',
        Boolean: '',
        Timestamp: '',
        Date: '',
        IntlString: '',
        Ref: '',
        Collection: '',
        Array: '',
        Name: '',
        Enum: '',
        Size: '',
        Description: '',
        ShortDescription: '',
        Descriptor: '',
        TargetClass: '',
        Role: '',
        Roles: '',
        Hyperlink: '',
        Private: '',
        Object: '',
        System: '',
        CreatedBy: '',
        CreatedDate: '',
        Status: '',
        Account: '',
        StatusCategory: '',
        Rank: '',
        Members: '',
        Owners: '',
        Permission: '',
        CreateObject: '',
        UpdateObject: '',
        DeleteObject: '',
        ForbidDeleteObject: '',
        UpdateSpace: '',
        ArchiveSpace: '',
        CreateObjectDescription: '',
        UpdateObjectDescription: '',
        DeleteObjectDescription: '',
        ForbidDeleteObjectDescription: '',
        UpdateSpaceDescription: '',
        ArchiveSpaceDescription: '',
        AutoJoin: '',
        AutoJoinDescr: '',
        RBAC: '',
        RBACDescr: '',
        Version: '',
        Collaborator: '',
        Collaborators: '',
        RoleAdmin: '',
        Archived: '',
        AddedCollaborator: '',
        RemovedCollaborator: ''
    },
    descriptor: {
        SpacesType: ''
    },
    spaceType: {
        SpacesType: ''
    },
    permission: {
        CreateObject: '',
        UpdateObject: '',
        DeleteObject: '',
        ForbidDeleteObject: '',
        UpdateSpace: '',
        ArchiveSpace: ''
    },
    role: {
        Admin: ''
    },
    metadata: {
        DisablePermissions: ''
    }
});
//# sourceMappingURL=component.js.map